<template>
  <div>
    <br><br><br>
    <h4>{{symbol}}</h4>
    <select name="pais" id="pais" class="form-control" @change="onChange($event)" required>
      <option v-for="(tag, index) in selectData" :value="index" :key="index" >
        {{tag}}
      </option>
    </select>
    <div v-for="(data, index) in rootData" :key="index">
      {{layouts[index].title}}
      <Plotly :data="data" :layout="layout" :display-mode-bar="true"></Plotly>
    </div>
  </div>
</template>
<script>
import { Plotly } from 'vue-plotly'
import { regresiones } from '../services/multiSnifferService'
export default {
  components: {
    Plotly
  },
  data: () => ({
    layouts: [],
    rootData: [],
    selectData: [],
    dataJson: null,
    symbol: '',
    layout: {
      title: 'My graph'
    }
  }),
  async mounted () {
    await this.loadData()
    this.processData(0)
  },
  methods: {
    onChange (e) {
      this.processData(e.target.value)
    },
    async loadData () {
      var urlString = window.location.href
      console.log(urlString, 'url-string')
      var url = new URL(urlString)
      this.symbol = url.searchParams.get('symbol')
      this.dataJson = await regresiones(this.symbol)
      this.selectData = this.dataJson.data.map(item => item.tag)
    },
    processData (index) {
      let {date, regresiones} = this.dataJson.data[index].data
      console.log(date)
      let dataArray = []
      for (let key of Object.keys(regresiones)) {
        for (let key2 of Object.keys(regresiones[key])) {
          let data = []
          for (let key3 of Object.keys(regresiones[key][key2])) {
            data.push({
              y: regresiones[key][key2][key3],
              x: date,
              name: key3,
              type: 'line'
            })
          }
          dataArray.push({data, title: `${this.symbol} ${key} ${key2}`})
        }
      }
      this.layouts = dataArray.map(item => ({title: item.title, xaxis: {type: 'date'}}))
      this.rootData = dataArray
      console.log(this.data)
    }
  }

}

</script>

<style>
.container{
  padding-top: 5%;
}

.chart-container {
  position: relative;
  margin: auto;
  height: 50vh !important;
  width: 80vw !important;
}
</style>



// WEBPACK FOOTER //
// src/components/graficaLineal.vue